/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_CASH_RECEIPT_SUMMARY_DISPLAY =
  'REFRESH_CASH_RECEIPT_SUMMARY_DISPLAY';
export const SET_SELECTED_INPUT_CASH_RECEIPT_SUMMARY =
  'SET_SELECTED_INPUT_CASH_RECEIPT_SUMMARY';
export const GET_MANUFACTURER_LIST_CASH_RECEIPT_SUMMARY =
  'GET_MANUFACTURER_LIST_CASH_RECEIPT_SUMMARY';

export const IS_LOADING_ADJUSTMENT_REASON_CODE =
  'IS_LOADING_ADJUSTMENT_REASON_CODE';
export const REFRESH_CASH_RECEIPT_SUMMARY = 'REFRESH_CASH_RECEIPT_SUMMARY';
export const GET_RESULT_GRID_CASH_RECEIPT_SUMMARY =
  'GET_RESULT_GRID_CASH_RECEIPT_SUMMARY';
export const HANDLE_ERROR_MESSAGE_CRS = 'HANDLE_ERROR_MESSAGE_CRS';
export const SET_SELECTED_REPORT_DRUG = 'SET_SELECTED_REPORT_DRUG';
